const ICONS = {
  TIMES: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ fill: "#bf4342" }}
        d="M7.78516 5.75L11.4062 2.16406L12.1445 1.42578C12.25 1.32031 12.25 1.14453 12.1445 1.00391L11.3711 0.230469C11.2305 0.125 11.0547 0.125 10.9492 0.230469L6.625 4.58984L2.26562 0.230469C2.16016 0.125 1.98438 0.125 1.84375 0.230469L1.07031 1.00391C0.964844 1.14453 0.964844 1.32031 1.07031 1.42578L5.42969 5.75L1.07031 10.1094C0.964844 10.2148 0.964844 10.3906 1.07031 10.5312L1.84375 11.3047C1.98438 11.4102 2.16016 11.4102 2.26562 11.3047L6.625 6.94531L10.2109 10.5664L10.9492 11.3047C11.0547 11.4102 11.2305 11.4102 11.3711 11.3047L12.1445 10.5312C12.25 10.3906 12.25 10.2148 12.1445 10.1094L7.78516 5.75Z"
        fill="#6A7082"
      />
    </svg>
  ),

  CHECK: (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ fill: "#28857c" }}
        d="M4.37891 7.84375C4.57422 8.03906 4.90625 8.03906 5.10156 7.84375L10.8438 2.10156C11.0391 1.90625 11.0391 1.57422 10.8438 1.37891L10.1406 0.675781C9.94531 0.480469 9.63281 0.480469 9.4375 0.675781L4.75 5.36328L2.54297 3.17578C2.34766 2.98047 2.03516 2.98047 1.83984 3.17578L1.13672 3.87891C0.941406 4.07422 0.941406 4.40625 1.13672 4.60156L4.37891 7.84375Z"
        fill="#2F6BFF"
      />
    </svg>
  ),

  TRASH: (
    <svg
      width="13"
      height="15"
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ fill: "#262626" }}
        d="M0.6875 10.3438C0.6875 10.9238 1.13867 11.375 1.71875 11.375H7.90625C8.46484 11.375 8.9375 10.9238 8.9375 10.3438V3.125H0.6875V10.3438ZM6.53125 4.84375C6.53125 4.67188 6.68164 4.5 6.875 4.5C7.04688 4.5 7.21875 4.67188 7.21875 4.84375V9.65625C7.21875 9.84961 7.04688 10 6.875 10C6.68164 10 6.53125 9.84961 6.53125 9.65625V4.84375ZM4.46875 4.84375C4.46875 4.67188 4.61914 4.5 4.8125 4.5C4.98438 4.5 5.15625 4.67188 5.15625 4.84375V9.65625C5.15625 9.84961 4.98438 10 4.8125 10C4.61914 10 4.46875 9.84961 4.46875 9.65625V4.84375ZM2.40625 4.84375C2.40625 4.67188 2.55664 4.5 2.75 4.5C2.92188 4.5 3.09375 4.67188 3.09375 4.84375V9.65625C3.09375 9.84961 2.92188 10 2.75 10C2.55664 10 2.40625 9.84961 2.40625 9.65625V4.84375ZM9.28125 1.0625H6.70312L6.48828 0.675781C6.40234 0.503906 6.20898 0.375 6.03711 0.375H3.56641C3.39453 0.375 3.17969 0.503906 3.11523 0.675781L2.92188 1.0625H0.34375C0.150391 1.0625 0 1.23438 0 1.40625V2.09375C0 2.28711 0.150391 2.4375 0.34375 2.4375H9.28125C9.45312 2.4375 9.625 2.28711 9.625 2.09375V1.40625C9.625 1.23438 9.45312 1.0625 9.28125 1.0625Z"
        fill="white"
      />
    </svg>
  ),

  PEN: (
    <svg
      width="16"
      height="15"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{ fill: "#262626" }}
        d="M6.66406 2.08594L1.23438 7.51562L1 9.74219C0.960938 10.0352 1.21484 10.2891 1.50781 10.25L3.73438 10.0156L9.16406 4.58594L6.66406 2.08594ZM10.707 1.71484L9.53516 0.542969C9.18359 0.171875 8.57812 0.171875 8.20703 0.542969L7.11328 1.63672L9.61328 4.13672L10.707 3.04297C11.0781 2.67188 11.0781 2.06641 10.707 1.71484Z"
        fill="white"
      />
    </svg>
  ),

  ACTIVATION_COUNT: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g id="Group_58" transform="translate(-1565 244)">
        <path
          id="Ellipse_5"
          d="M9.773.909A8.866,8.866,0,0,0,6.323,17.94a8.866,8.866,0,0,0,6.9-16.335c-.211-.089-.424-.17-.775-.286A8.6,8.6,0,0,0,9.773.909m0-.909A9.773,9.773,0,1,1,0,9.773,9.773,9.773,0,0,1,9.773,0Z"
          transform="translate(1575.455 -233.545)"
          fill="#fff"
        />
        <path
          id="Subtraction_6"
          d="M9.773,19.546A9.775,9.775,0,0,1,5.969.768a9.77,9.77,0,0,1,13.577,9,9.9,9.9,0,0,1-.1,1.4,9.123,9.123,0,0,0-.94.13,8.962,8.962,0,0,0,.13-1.526A8.866,8.866,0,0,0,1.605,6.323,8.861,8.861,0,0,0,9.773,18.637a8.964,8.964,0,0,0,1.526-.13,9.124,9.124,0,0,0-.13.94A9.893,9.893,0,0,1,9.773,19.546Zm0-1.818A7.954,7.954,0,0,1,4.148,4.148,7.954,7.954,0,0,1,17.727,9.773a8,8,0,0,1-.2,1.77,9.056,9.056,0,0,0-1.05.4,7.032,7.032,0,1,0-4.537,4.537,9.056,9.056,0,0,0-.4,1.05A8,8,0,0,1,9.773,17.727Zm4.461-4.336h0a1.475,1.475,0,0,0-.806-.319c-.056,0-.118-.006-.189-.006s-.171,0-.268.006H12.9A3.085,3.085,0,0,1,10.426,11.8a.9.9,0,0,1-.053-.085c-.01-.016-.024-.041-.04-.071s-.02-.034-.03-.053h0a.013.013,0,0,0,0-.006l-.013-.027,0-.009,0,0,0,0,.061-.03s0,.005,0,.008,0,.005,0,.008l.347-.181.377-.175,0,0,.033-.018,0-.006,0-.006,0,0c.029.055.057.106.076.138a2.131,2.131,0,0,0,1.706.881h.059c.092,0,.2-.007.3-.007s.177,0,.257.009a2.492,2.492,0,0,1,1.464.651,9.166,9.166,0,0,0-.726.574Z"
          transform="translate(1565 -244)"
          fill="#fff"
        />
        <path
          id="Subtraction_5"
          d="M8.543,25.517h0a13.679,13.679,0,0,1-6.308-4.924A13.472,13.472,0,0,1,0,15.278c.329.15.67.287,1.014.409a12.761,12.761,0,0,0,7.419,8.805c.022.342.059.687.109,1.023ZM26.951,11.172h0c-.311-.1-.631-.184-.95-.261a12.752,12.752,0,0,0-7.639-9.865l-.031-.013C18.295.689,18.246.342,18.186,0a13.647,13.647,0,0,1,8.765,11.172Z"
          transform="translate(1566.593 -241.774)"
          fill="#fff"
        />
        <circle
          id="Ellipse_11"
          cx="1.818"
          cy="1.818"
          r="1.818"
          transform="translate(1573.182 -218.545)"
          fill="#fff"
        />
        <circle
          id="Ellipse_12"
          cx="1.818"
          cy="1.818"
          r="1.818"
          transform="translate(1583.182 -243.091)"
          fill="#fff"
        />
        <path
          id="Union_3"
          d="M4.625,10.84a2.037,2.037,0,0,1-1.454-.6L.6,7.67A2.045,2.045,0,0,1,3.492,4.777L4.625,5.91,9.936.6a2.045,2.045,0,0,1,2.893,2.893L6.08,10.241a2.04,2.04,0,0,1-1.447.6Z"
          transform="translate(1578.26 -228.555)"
          fill="#fff"
        />
        <path
          id="Path_7"
          d="M1574.17-215.656l-.9-.141a2.827,2.827,0,0,1,.848-1.633,2.5,2.5,0,0,1,1.512-.7,5.052,5.052,0,0,1,.557,0,1.345,1.345,0,0,0,1.433-.6h0c.016-.027.046-.08.076-.138l0,0-.008.013.035.017,0,0,.377.175.347.181c0-.005,0-.011,0-.016l.061.031,0,0,0,0-.017.036-.006.013,0-.008c-.009.017-.019.036-.031.055l-.04.071a.967.967,0,0,1-.053.085h0a2.228,2.228,0,0,1-2.211.993,4.323,4.323,0,0,0-.458,0A1.815,1.815,0,0,0,1574.17-215.656Z"
          transform="translate(-4.512 -13.709)"
          fill="#fff"
        />
        <path
          id="Path_10"
          d="M1582.744-214.869a.457.457,0,0,1-.244-.07.453.453,0,0,1-.14-.627h0l.01-.015h0l1.5-2.356.768.487-1.505,2.372h0A.455.455,0,0,1,1582.744-214.869Z"
          transform="translate(-7.925 -14.216)"
          fill="#fff"
        />
        <path
          id="Intersection_1"
          d="M13,8.545a3.332,3.332,0,0,0,1.74-.48,2.765,2.765,0,0,0,.079-.656,3.078,3.078,0,0,0-3.182-2.955A3.078,3.078,0,0,0,8.455,7.409,2.741,2.741,0,0,0,8.67,8.48,3.231,3.231,0,0,0,10.2,7.727l.3-.268.3.268a3.3,3.3,0,0,0,2.2.819M13,9a3.755,3.755,0,0,1-2.5-.934,3.731,3.731,0,0,1-2.092.912A3.225,3.225,0,0,1,8,7.409,3.528,3.528,0,0,1,11.637,4a3.528,3.528,0,0,1,3.636,3.409,3.213,3.213,0,0,1-.141.944A3.784,3.784,0,0,1,13,9Z"
          transform="translate(1562.909 -244.363)"
          fill="#fff"
        />
        <path
          id="Path_12"
          d="M.712-.607a2.718,2.718,0,0,0-.258.256V2.111a.91.91,0,0,0,.909.909h.909a.91.91,0,0,0,.909-.909V2.083L3.29.35A4.932,4.932,0,0,1,1.939.093L1.913.083a5.778,5.778,0,0,1-1.2-.69M.757-1.13h0a6.775,6.775,0,0,0,1.316.79,3.066,3.066,0,0,0,1.7.195l-.14,2.256A1.364,1.364,0,0,1,2.273,3.475H1.364A1.364,1.364,0,0,1,0,2.111V-.517S.487-1.13.757-1.13Z"
          transform="translate(1572.727 -235.656)"
          fill="#fff"
        />
        <path
          id="Path_13"
          d="M1579.737-223.818a1.223,1.223,0,0,1-.884-.393,1.322,1.322,0,0,1-.036-1.755l.361.276a.869.869,0,0,0,.007,1.168.741.741,0,0,0,.989.106l.251.379A1.235,1.235,0,0,1,1579.737-223.818Z"
          transform="translate(-7.365 -9.837)"
          fill="#fff"
        />
        <path
          id="Path_14"
          d="M1579.057-224.013a1.405,1.405,0,0,1-.744-.226l-.037-.024,0-.007h0l.019-.03.224-.339-.007,0,0-.006.038.024a.838.838,0,0,0,1.11-.129,1.1,1.1,0,0,0-.011-1.457l.355-.284a1.638,1.638,0,0,1,.377,1.1,1.5,1.5,0,0,1-.386.947,1.3,1.3,0,0,1-.773.418A1.227,1.227,0,0,1,1579.057-224.013Z"
          transform="translate(-2.241 -9.55)"
          fill="#fff"
        />
        <path
          id="Path_10-2"
          d="M1584.177-214.869a.458.458,0,0,0,.244-.07.453.453,0,0,0,.14-.627h0l-.01-.015h0l-1.5-2.356-.768.487,1.505,2.372h0A.455.455,0,0,0,1584.177-214.869Z"
          transform="translate(-9.46 -14.216)"
          fill="#fff"
        />
      </g>
    </svg>
  ),

  ACTIVATIONS_MONTH: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.435"
      height="30"
      viewBox="0 0 27.435 30"
    >
      <g id="Group_6" transform="translate(0 0)">
        <path
          id="Subtraction_1"
          d="M13.747,30H2.776A2.8,2.8,0,0,1,0,27.187V11.25H25.907v4.556a9.07,9.07,0,0,0-11.1.3V15.7a.7.7,0,0,0-.694-.7H11.8a.7.7,0,0,0-.694.7v2.344a.7.7,0,0,0,.694.7h.77A9.707,9.707,0,0,0,13.745,30ZM4.4,22.5a.7.7,0,0,0-.694.7v2.344a.7.7,0,0,0,.694.7H6.709a.7.7,0,0,0,.694-.7V23.2a.7.7,0,0,0-.694-.7Zm0-7.5a.7.7,0,0,0-.694.7v2.344a.7.7,0,0,0,.694.7H6.709a.7.7,0,0,0,.694-.7V15.7a.7.7,0,0,0-.694-.7ZM25.907,9.374H0V6.562A2.8,2.8,0,0,1,2.776,3.749H5.552V.937A.932.932,0,0,1,6.477,0h1.85a.932.932,0,0,1,.925.937V3.749h7.4V.937A.932.932,0,0,1,17.581,0h1.85a.932.932,0,0,1,.925.937V3.749h2.776a2.8,2.8,0,0,1,2.776,2.812V9.373Z"
          transform="translate(0 0)"
          fill="#fff"
        />
        <path
          id="Icon_awesome-check"
          d="M4.773,15.067a1.565,1.565,0,0,1-1.114-.461l-4.2-4.2a1.577,1.577,0,0,1,0-2.227l.913-.913a1.575,1.575,0,0,1,2.227,0L4.773,9.438l5.4-5.4a1.575,1.575,0,0,1,2.227,0l.913.913a1.577,1.577,0,0,1,0,2.227L5.886,14.606A1.565,1.565,0,0,1,4.773,15.067ZM.976,9.294l3.8,3.8L11.8,6.065l-.513-.513L4.773,12.066,1.488,8.782Z"
          transform="translate(13.662 14.934)"
          fill="#fff"
        />
      </g>
    </svg>
  ),

  ACTIVATIONS_TODAY: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30.882"
      viewBox="0 0 30 30.882"
    >
      <path
        id="Path_7"
        d="M3.529,30.882A3.533,3.533,0,0,1,0,27.353V6.176A3.533,3.533,0,0,1,3.529,2.647H5.735V5.074a2.427,2.427,0,0,0,4.853,0V2.647h8.823V5.074a2.426,2.426,0,1,0,4.853,0V2.647h2.206A3.533,3.533,0,0,1,30,6.176V27.353a3.533,3.533,0,0,1-3.529,3.529ZM2.206,26.912a1.325,1.325,0,0,0,1.323,1.323H26.471a1.325,1.325,0,0,0,1.323-1.323V10.588H2.206ZM14.061,25.75a1.318,1.318,0,0,1-.918-.308l-5.07-4.254a1.323,1.323,0,0,1-.163-1.865l.567-.676a1.324,1.324,0,0,1,1.865-.163l3.433,2.881,5.194-7.418a1.323,1.323,0,0,1,1.844-.325l.723.506a1.323,1.323,0,0,1,.325,1.843l-6.468,9.237a1.326,1.326,0,0,1-1.331.541ZM20.735,5.074V1.1a1.1,1.1,0,1,1,2.206,0V5.074a1.1,1.1,0,1,1-2.206,0Zm-13.676,0V1.1a1.1,1.1,0,1,1,2.206,0V5.074a1.1,1.1,0,1,1-2.206,0Z"
        fill="#fff"
      />
    </svg>
  ),

  TOTAL_CLICKED: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="32"
      viewBox="0 0 30 32"
    >
      <g id="Group_60" transform="translate(-1180 -589)">
        <path
          id="Subtraction_8"
          d="M16.748,30.824H3.146A3.118,3.118,0,0,1,0,27.742L.016,6.165a3.043,3.043,0,0,1,.91-2.177,3.132,3.132,0,0,1,2.22-.905H4.719V0H7.865V3.083H20.449V0h3.146V3.083h1.573a3.118,3.118,0,0,1,3.146,3.083v9.077a11.512,11.512,0,0,0-2.875-.362c-.09,0-.181,0-.271,0V10.789H3.146V27.742h11.97a9.716,9.716,0,0,0,1.631,3.081Zm-2.591-9.247H6.292V13.871h7.865v7.706Z"
          transform="translate(1180 589)"
          fill="#fff"
        />
        <path
          id="Path_2"
          d="M11.271-28.644a2.613,2.613,0,0,1-1.045,2.165A5.424,5.424,0,0,1,7.3-25.5v1.737H6.055v-1.7a10.735,10.735,0,0,1-3.889-.729v-2.237a10.966,10.966,0,0,0,1.9.644,10.853,10.853,0,0,0,1.985.33v-2.627l-.609-.22A6.89,6.89,0,0,1,2.9-31.741a2.654,2.654,0,0,1-.75-1.919A2.443,2.443,0,0,1,3.18-35.681a5.477,5.477,0,0,1,2.876-.962v-1.3H7.3v1.263a10.946,10.946,0,0,1,3.762.78l-.854,1.983A10.41,10.41,0,0,0,7.3-34.575v2.5a14.444,14.444,0,0,1,2.521,1.1,3.339,3.339,0,0,1,1.1,1.025A2.409,2.409,0,0,1,11.271-28.644Zm-2.735.127a.743.743,0,0,0-.309-.6,4.123,4.123,0,0,0-.927-.508v2.11Q8.536-27.712,8.536-28.517ZM4.883-33.66a.779.779,0,0,0,.277.614,3.344,3.344,0,0,0,.895.5v-1.991Q4.883-34.381,4.883-33.66Z"
          transform="translate(1198.729 644.763)"
          fill="#fff"
        />
      </g>
    </svg>
  ),

  TOTAL_ACTIVATED: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="35"
      viewBox="0 0 30 35"
    >
      <g id="Group_61" transform="translate(-696.293 -779.193)">
        <path
          id="Subtraction_7"
          d="M14.819,28.032H2.766A2.7,2.7,0,0,1,0,25.4V10.512H25.814v5.53a10.157,10.157,0,0,0-3.688-.058V14.673a.676.676,0,0,0-.691-.657h-2.3a.676.676,0,0,0-.691.657v2.19a.637.637,0,0,0,.177.438,9.224,9.224,0,0,0-3.865,4.716v-.335a.676.676,0,0,0-.691-.657h-2.3a.676.676,0,0,0-.691.657v2.19a.676.676,0,0,0,.691.657h2.3a.719.719,0,0,0,.2-.028c-.007.141-.011.286-.011.432a8.659,8.659,0,0,0,.571,3.1ZM4.379,21.024a.676.676,0,0,0-.691.657v2.19a.676.676,0,0,0,.691.657h2.3a.676.676,0,0,0,.691-.657v-2.19a.676.676,0,0,0-.691-.657Zm7.375-7.008a.676.676,0,0,0-.691.657v2.19a.676.676,0,0,0,.691.657h2.3a.676.676,0,0,0,.691-.657v-2.19a.676.676,0,0,0-.691-.657Zm-7.375,0a.676.676,0,0,0-.691.657v2.19a.676.676,0,0,0,.691.657h2.3a.676.676,0,0,0,.691-.657v-2.19a.676.676,0,0,0-.691-.657ZM25.814,8.76H0V6.132A2.7,2.7,0,0,1,2.766,3.5H5.532V.876A.9.9,0,0,1,6.454,0H8.3a.9.9,0,0,1,.922.876V3.5h7.375V.876A.9.9,0,0,1,17.516,0H19.36a.9.9,0,0,1,.922.876V3.5h2.765a2.7,2.7,0,0,1,2.766,2.628V8.759Z"
          transform="translate(696.293 779.193)"
          fill="#fff"
        />
        <path
          id="Path_1"
          d="M10.88-28.538a2.7,2.7,0,0,1-1,2.19,5.014,5.014,0,0,1-2.8.99V-23.6H5.888v-1.723a9.794,9.794,0,0,1-3.722-.737v-2.262a10.117,10.117,0,0,0,1.822.651,9.88,9.88,0,0,0,1.9.334V-30l-.583-.223a6.52,6.52,0,0,1-2.44-1.453,2.768,2.768,0,0,1-.718-1.941,2.518,2.518,0,0,1,.987-2.044,5.063,5.063,0,0,1,2.753-.973v-1.311H7.08v1.277a10,10,0,0,1,3.6.788l-.818,2.005a9.516,9.516,0,0,0-2.783-.668v2.528A13.466,13.466,0,0,1,9.493-30.9a3.277,3.277,0,0,1,1.052,1.037A2.542,2.542,0,0,1,10.88-28.538Zm-2.618.129a.766.766,0,0,0-.3-.608,3.891,3.891,0,0,0-.887-.514V-27.4Q8.263-27.6,8.263-28.41Zm-3.5-5.2a.808.808,0,0,0,.265.621,3.159,3.159,0,0,0,.857.5V-34.5Q4.766-34.34,4.766-33.612Z"
          transform="translate(715.413 837.795)"
          fill="#fff"
        />
      </g>
    </svg>
  ),

  TOTAL_WITHDRAW: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g id="Group_62" transform="translate(-1787 -588)">
        <path
          id="Ellipse_3"
          d="M15,2A13,13,0,0,0,5.808,24.192,13,13,0,0,0,24.192,5.808,12.915,12.915,0,0,0,15,2m0-2A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z"
          transform="translate(1787 588)"
          fill="#fff"
        />
        <g id="Group_4" transform="translate(1790.53 595.5)">
          <path
            id="Subtraction_9"
            d="M22.078,9.865H17.259a6,6,0,0,0-.489-.986h5.309V3.453H15.173v3.7a6.155,6.155,0,0,0-.985-.587l0-4.593a.985.985,0,0,1,.982-.987h.493V0h.987V.986H20.6V0h.987V.986h.493a.988.988,0,0,1,.986.987V8.878A.987.987,0,0,1,22.078,9.865Zm-16.272,0H.937A.932.932,0,0,1,0,8.94V3.7H8.744V6.631A6.144,6.144,0,0,0,7.456,7.5a.235.235,0,0,0-.2-.1H6.48a.233.233,0,0,0-.234.231V8.4a.234.234,0,0,0,.21.23,6.01,6.01,0,0,0-.65,1.234ZM3.982,7.4a.233.233,0,0,0-.234.231V8.4a.233.233,0,0,0,.234.231h.781A.233.233,0,0,0,5,8.4V7.63A.233.233,0,0,0,4.763,7.4Zm-2.5,0a.233.233,0,0,0-.234.231V8.4a.233.233,0,0,0,.234.231h.781A.233.233,0,0,0,2.5,8.4V7.63A.233.233,0,0,0,2.264,7.4Zm5-2.466a.233.233,0,0,0-.234.231v.771a.233.233,0,0,0,.234.231h.781A.233.233,0,0,0,7.5,5.934V5.163a.233.233,0,0,0-.234-.231Zm-2.5,0a.233.233,0,0,0-.234.231v.771a.233.233,0,0,0,.234.231h.781A.233.233,0,0,0,5,5.934V5.163a.233.233,0,0,0-.234-.231Zm-2.5,0a.233.233,0,0,0-.234.231v.771a.233.233,0,0,0,.234.231h.781A.233.233,0,0,0,2.5,5.934V5.163a.233.233,0,0,0-.234-.231ZM18.625,6.905H16.159V4.439h2.466V6.9ZM8.744,3.083H0V2.158a.932.932,0,0,1,.937-.925h.937V.308A.311.311,0,0,1,2.186,0h.625a.31.31,0,0,1,.312.308v.925h2.5V.308A.31.31,0,0,1,5.934,0h.625a.311.311,0,0,1,.312.308v.925h.937a.932.932,0,0,1,.937.925v.924Z"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_9"
          d="M7.343-32.337a1.61,1.61,0,0,1-.6,1.3,2.98,2.98,0,0,1-1.666.59V-29.4H4.373v-1.027a5.818,5.818,0,0,1-2.214-.439v-1.348a6.011,6.011,0,0,0,1.084.388,5.868,5.868,0,0,0,1.131.2v-1.583l-.347-.133A3.878,3.878,0,0,1,2.575-34.2a1.651,1.651,0,0,1-.427-1.157,1.5,1.5,0,0,1,.587-1.218,3.009,3.009,0,0,1,1.638-.58v-.781h.709v.761a5.939,5.939,0,0,1,2.142.47l-.486,1.2a5.653,5.653,0,0,0-1.656-.4v1.507a8,8,0,0,1,1.436.664,1.951,1.951,0,0,1,.626.618A1.517,1.517,0,0,1,7.343-32.337Zm-1.557.077a.457.457,0,0,0-.176-.363,2.314,2.314,0,0,0-.528-.306v1.272Q5.786-31.775,5.786-32.26Zm-2.08-3.1a.482.482,0,0,0,.158.37,1.879,1.879,0,0,0,.51.3v-1.2Q3.706-35.794,3.706-35.36Z"
          transform="translate(1797.316 641.184)"
          fill="#fff"
        />
      </g>
    </svg>
  ),
  PLAYLIST: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48px"
      height="48px"
      viewBox="0 -5  48 48"
    >
      <path d="M5 31.5v-3h15.3v3Zm0-8.25v-3h23.65v3ZM5 15v-3h23.65v3Zm27.1 27V25.9L43 33.95Z" />
    </svg>
  ),
  SUBRESELLER: (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.93887 2.06651V0.413043C9.93887 0.184579 9.75429 0 9.52582 0H0.80028C0.571815 0 0.387236 0.184579 0.387236 0.413043V2.06651C0.171679 2.07942 7.99747e-06 2.25883 7.99747e-06 2.47826V4.17819C-0.000818613 4.49061 0.0624414 4.79988 0.185878 5.08689C0.24138 5.21855 0.309791 5.34246 0.387236 5.45992V9.91304C0.387236 10.1402 0.571815 10.3261 0.80028 10.3261H9.52582C9.75429 10.3261 9.93887 10.1415 9.93887 9.91304V5.45992C10.0175 5.34216 10.0849 5.21727 10.1402 5.08689C10.2628 4.79905 10.3261 4.49314 10.3261 4.17819V2.47826C10.3261 2.25883 10.1544 2.07942 9.93887 2.06651ZM1.31658 0.929348H9.00952V2.06522H1.31658V0.929348ZM5.98914 9.39803H4.33696V8.05435H5.98914V9.39803ZM9.00952 9.39803H6.81523V7.6413C6.81523 7.41284 6.63065 7.22826 6.40218 7.22826H3.92392C3.69546 7.22826 3.51088 7.41284 3.51088 7.6413V9.39803H1.31658V6.27181C1.35402 6.28988 1.39274 6.30795 1.43275 6.32344C1.72059 6.44477 2.0265 6.50543 2.34145 6.50543C2.65639 6.50543 2.96101 6.44477 3.25014 6.32344C3.42827 6.24857 3.59607 6.15306 3.74967 6.03818C3.75225 6.03689 3.75483 6.03689 3.75741 6.03818C3.91149 6.15355 4.07928 6.24936 4.25694 6.32344C4.54478 6.44477 4.85069 6.50543 5.16563 6.50543C5.48058 6.50543 5.7852 6.44477 6.07433 6.32344C6.25245 6.24857 6.42025 6.15306 6.57385 6.03818C6.57643 6.03689 6.57902 6.03689 6.5816 6.03818C6.73568 6.15355 6.90346 6.24936 7.08112 6.32344C7.36896 6.44477 7.67487 6.50543 7.98982 6.50543C8.30476 6.50543 8.60938 6.44477 8.89851 6.32344C8.93724 6.30666 8.97596 6.28988 9.01468 6.27181V9.39803H9.00952ZM9.39675 4.17819C9.39675 4.95007 8.76427 5.57609 7.98595 5.57609C7.45931 5.57609 6.9998 5.29083 6.75714 4.86746C6.71971 4.80292 6.65259 4.76291 6.57772 4.76291H6.56998C6.49641 4.76291 6.428 4.80292 6.39056 4.86746C6.26673 5.08342 6.08792 5.26275 5.87232 5.38722C5.65671 5.51168 5.412 5.57685 5.16305 5.57609C4.63771 5.57609 4.17949 5.29212 3.93683 4.87004C3.89811 4.80421 3.8284 4.76291 3.75225 4.76291C3.67609 4.76291 3.6051 4.80421 3.56767 4.87004C3.44311 5.08518 3.26408 5.26371 3.04859 5.38766C2.83309 5.5116 2.58875 5.57659 2.34016 5.57609C1.56183 5.57609 0.929356 4.95007 0.929356 4.17819V3.00102C0.929356 2.99715 0.931937 2.99457 0.93581 2.99457H9.39029C9.39417 2.99457 9.39675 2.99715 9.39675 3.00102V4.17819Z"
      />
      <path
        d="M18.7525 7.93145V6.87323C18.7525 6.72702 18.6343 6.60889 18.4881 6.60889H12.9038C12.7576 6.60889 12.6394 6.72702 12.6394 6.87323V7.93145C12.5015 7.93971 12.3916 8.05454 12.3916 8.19497V9.28293C12.3911 9.48288 12.4316 9.68081 12.5106 9.8645C12.5461 9.94876 12.5899 10.0281 12.6394 10.1032V12.9532C12.6394 13.0986 12.7576 13.2176 12.9038 13.2176H18.4881C18.6343 13.2176 18.7525 13.0995 18.7525 12.9532V10.1032C18.8028 10.0279 18.846 9.94794 18.8813 9.8645C18.9598 9.68028 19.0003 9.4845 19.0003 9.28293V8.19497C19.0003 8.05454 18.8904 7.93971 18.7525 7.93145ZM13.2342 7.20367H18.1577V7.93063H13.2342V7.20367ZM16.2246 12.6236H15.1673V11.7637H16.2246V12.6236ZM18.1577 12.6236H16.7533V11.4993C16.7533 11.3531 16.6352 11.235 16.489 11.235H14.9029C14.7567 11.235 14.6386 11.3531 14.6386 11.4993V12.6236H13.2342V10.6228C13.2582 10.6344 13.283 10.646 13.3086 10.6559C13.4928 10.7335 13.6886 10.7724 13.8901 10.7724C14.0917 10.7724 14.2866 10.7335 14.4717 10.6559C14.5857 10.608 14.6931 10.5468 14.7914 10.4733C14.793 10.4725 14.7947 10.4725 14.7963 10.4733C14.895 10.5472 15.0023 10.6085 15.116 10.6559C15.3003 10.7335 15.496 10.7724 15.6976 10.7724C15.8992 10.7724 16.0941 10.7335 16.2792 10.6559C16.3932 10.608 16.5006 10.5468 16.5989 10.4733C16.6005 10.4725 16.6022 10.4725 16.6038 10.4733C16.7024 10.5472 16.8098 10.6085 16.9235 10.6559C17.1077 10.7335 17.3035 10.7724 17.5051 10.7724C17.7066 10.7724 17.9016 10.7335 18.0866 10.6559C18.1114 10.6451 18.1362 10.6344 18.161 10.6228V12.6236H18.1577ZM18.4055 9.28293C18.4055 9.77693 18.0007 10.1776 17.5026 10.1776C17.1656 10.1776 16.8715 9.99502 16.7162 9.72406C16.6922 9.68276 16.6493 9.65715 16.6013 9.65715H16.5964C16.5493 9.65715 16.5055 9.68276 16.4816 9.72406C16.4023 9.86228 16.2879 9.97705 16.1499 10.0567C16.0119 10.1364 15.8553 10.1781 15.696 10.1776C15.3597 10.1776 15.0665 9.99584 14.9112 9.72571C14.8864 9.68358 14.8418 9.65715 14.793 9.65715C14.7443 9.65715 14.6989 9.68358 14.6749 9.72571C14.5952 9.8634 14.4806 9.97766 14.3427 10.057C14.2048 10.1363 14.0484 10.1779 13.8893 10.1776C13.3912 10.1776 12.9864 9.77693 12.9864 9.28293V8.52954C12.9864 8.52706 12.988 8.52541 12.9905 8.52541H18.4014C18.4039 8.52541 18.4055 8.52706 18.4055 8.52954V9.28293Z"
      />
      <path
        d="M15.6824 4.30746L15.6824 4.30756C15.6826 4.36149 15.7042 4.41314 15.7424 4.45114C15.7807 4.48914 15.8325 4.51038 15.8864 4.51019C15.9404 4.51 15.992 4.48839 16.03 4.45012C16.0323 4.44781 16.0346 4.44544 16.0367 4.44303C16.0706 4.40548 16.0892 4.35668 16.0891 4.30612L16.0891 4.30602L16.0819 2.2931C16.0815 2.1808 15.9902 2.09008 15.8779 2.09047L11.8518 2.10472C11.7979 2.10491 11.7463 2.12652 11.7083 2.16479C11.6703 2.20306 11.649 2.25486 11.6492 2.30879C11.6494 2.36272 11.671 2.41436 11.7093 2.45236C11.7475 2.49036 11.7993 2.51161 11.8533 2.51141L15.676 2.49789L15.6824 4.30746Z"
      />
    </svg>
  ),
  LOCK: (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="12px"
      height="12px"
    >
      <path
        style={{ fill: "black" }}
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="2"
        d="M36,21c0,0,0-4.9,0-6c0-6.1-4.9-11-11-11c-6.1,0-11,4.9-11,11c0,1.1,0,6,0,6"
      />
      <path fill="none" d="M0 0H50V50H0z" />
      <path d="M41,20H9c-1.7,0-3,1.3-3,3v24c0,1.7,1.3,3,3,3h32c1.7,0,3-1.3,3-3V23C44,21.3,42.7,20,41,20z M27,35.2V38c0,1.1-0.9,2-2,2s-2-0.9-2-2v-2.8c-0.6-0.5-1-1.3-1-2.2c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3C28,33.9,27.6,34.7,27,35.2z" />
    </svg>
  ),

  PADLOCK: (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="12px"
      height="12px"
    >
      <path d="M 22.78125 0 C 21.605469 -0.00390625 20.40625 0.164063 19.21875 0.53125 C 12.902344 2.492188 9.289063 9.269531 11.25 15.59375 L 11.25 15.65625 C 11.507813 16.367188 12.199219 18.617188 12.625 20 L 9 20 C 7.300781 20 6 21.300781 6 23 L 6 47 C 6 48.699219 7.300781 50 9 50 L 41 50 C 42.699219 50 44 48.699219 44 47 L 44 23 C 44 21.300781 42.699219 20 41 20 L 14.75 20 C 14.441406 19.007813 13.511719 16.074219 13.125 15 L 13.15625 15 C 11.519531 9.722656 14.5 4.109375 19.78125 2.46875 C 25.050781 0.832031 30.695313 3.796875 32.34375 9.0625 C 32.34375 9.066406 32.34375 9.089844 32.34375 9.09375 C 32.570313 9.886719 33.65625 13.40625 33.65625 13.40625 C 33.746094 13.765625 34.027344 14.050781 34.386719 14.136719 C 34.75 14.226563 35.128906 14.109375 35.375 13.832031 C 35.621094 13.550781 35.695313 13.160156 35.5625 12.8125 C 35.5625 12.8125 34.433594 9.171875 34.25 8.53125 L 34.25 8.5 C 32.78125 3.761719 28.601563 0.542969 23.9375 0.0625 C 23.550781 0.0234375 23.171875 0 22.78125 0 Z M 25 30 C 26.699219 30 28 31.300781 28 33 C 28 33.898438 27.601563 34.6875 27 35.1875 L 27 38 C 27 39.101563 26.101563 40 25 40 C 23.898438 40 23 39.101563 23 38 L 23 35.1875 C 22.398438 34.6875 22 33.898438 22 33 C 22 31.300781 23.300781 30 25 30 Z" />
    </svg>
  ),
};

export default ICONS;
